module.exports = __webpack_public_path__ + "media/images/icons/ic-code-ac0b8c22344186a2618ecb9cd9036bbc.svg";